import { render, staticRenderFns } from "./YMmpCouponItem.vue?vue&type=template&id=56de944a&scoped=true&"
import script from "./YMmpCouponItem.vue?vue&type=script&lang=js&"
export * from "./YMmpCouponItem.vue?vue&type=script&lang=js&"
import style0 from "./YMmpCouponItem.vue?vue&type=style&index=0&id=56de944a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de944a",
  null
  
)

export default component.exports